'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _n2 = require('../../../@Neptune/scripts/_n');

var _n3 = _interopRequireDefault(_n2);

var _formSerialize = require('form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filters = {
	config: {
		delay: 100
	},
	data: {},
	timer: 2000,
	init: function init() {
		if (_n3.default.exists('[data-collection-filters]')) {
			Filters.start();
			Filters.bindURL();
		}
	},
	start: function start() {

		_n3.default.qsa('form[data-collection-filters] input').forEach(function (input) {

			input.addEventListener('input', Filters.run);
		});

		_n3.default.qsa('form[data-collection-filters] select').forEach(function (input) {

			input.addEventListener('change', Filters.run);
		});
	},
	run: function run() {
		_n3.default.qs('.collection-products').classList.add('loading');

		if (Filters.timer) clearTimeout(Filters.timer);

		Filters.timer = setTimeout(function () {
			Filters.value();
			if (!!Collection.reset) {
				Collection.reset();
				setTimeout(Collection.load, 20);
			} else {
				Neptune.templates.render('Products');
			}
			_n3.default.qs('.collection-products').classList.remove('loading');
		}, 1000);
	},
	value: function value() {
		var formData = new FormData(_n3.default.qs('form[data-collection-filters]'));
		var json = {};
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var pair = _step.value;

				if (typeof json[pair[0]] == 'undefined' && !!pair[1]) {
					json[pair[0]] = { tags: [], constraint: false };
				}
				if (!!pair[1]) json[pair[0]].tags.push(pair[1]);
				if (_n3.default.exists('form[data-collection-filters] [data-constraint][name="' + pair[0] + '"]')) {
					_n3.default.qs('form[data-collection-filters] [data-constraint][name="' + pair[0] + '"]').getAttribute('data-constraint') || false;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		Filters.data = json;
		Filters.bindURL(Filters.data);
		return json;
	},
	clear: function clear() {
		Filters.data = {};
		Filters.flat_data = [];
		_n3.default.qsa('[data-collection-filters] input[type=checkbox]').forEach(function (checkbox) {
			checkbox.checked = false;
		});
		Filters.bindURL(Filters.data);
		if (!!Collection.reset) {
			Collection.reset();
			setTimeout(Collection.load, 20);
		} else {
			Neptune.templates.render('Products');
		}
	},
	bindURL: function bindURL(data) {
		if (!!data) {
			// SET
			var url = document.location.href.split('?')[0] + '?';
			Object.keys(data).forEach(function (key) {
				url += 'filter[' + data[key].tags[0].substr(0, data[key].tags[0].lastIndexOf(':')) + ']=' + data[key].tags.map(function (tag) {
					return tag.split(':').reverse()[0];
				}).join() + '&';
			});
			url = url.substring(0, url.length - 1);
			window.history.replaceState(window.history.state || {}, document.title, url);
		} else {
			// GET
			Filters.data = {};
			Filters.flat_data = [];
			try {
				document.location.href.split('?')[1].split('&').forEach(function (param) {
					var p = param.split('=');
					if (p[0].indexOf('filter[') == -1) return false;
					var key = p[0].split('[')[1].split(']')[0];
					if (key) {
						Filters.data[key] = p[1].split(',').map(function (val) {
							return key + ':' + val;
						});
					} else {
						p[1].split(',').forEach(function (val) {
							Filters.flat_data.push(val);
						});
					}
				});
			} catch (e) {}
			_n3.default.qsa('[data-collection-filters] input[type=checkbox]').forEach(function (checkbox) {
				checkbox.checked = false;
			});
			Object.keys(Filters.data).forEach(function (key) {
				Filters.data[key].map(function (val) {
					val = val.replace('%20', ' ');
					if (_n3.default.exists('[value="' + val + '"]')) _n3.default.qs('[value="' + val + '"]').checked = true;
				});
			});
			Filters.flat_data.forEach(function (val) {
				val = val.replace('%20', ' ');
				if (_n3.default.exists('[value="' + val + '"]')) _n3.default.qs('[value="' + val + '"]').checked = true;
			});

			if (_n3.default.exists('.filter-format-range .ghost')) {
				_n3.default.qsa('.filter-format-range').forEach(function (rangeholder) {
					var range = _n3.default.array(_n3.default.qsa('input[type=checkbox]', rangeholder)).map(function (cb, i) {
						if (cb.checked) return i + 1;
					}).filter(function (i) {
						return i != undefined;
					});
					var min = Math.min.apply(Math, (0, _toConsumableArray3.default)(range));
					var max = Math.max.apply(Math, (0, _toConsumableArray3.default)(range));

					var slider = _n3.default.qs('.multirange.original');
					slider.value = min + ',' + max;

					var ghost = _n3.default.qs('.multirange.ghost');
					ghost.style.setProperty("--low", 100 * ((slider.valueLow - slider.min) / (slider.max - slider.min)) + 1 + "%");
					ghost.style.setProperty("--high", 100 * ((slider.valueHigh - slider.min) / (slider.max - slider.min)) - 1 + "%");
				});
			}

			return Filters.data;
		}
	}
};

window.Filters = Filters;

exports.default = Filters;